var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgUmbrella(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .drop {\n        opacity: 1;\n        animation: drop 3s ease-in-out infinite;\n      }\n\n      .drop:nth-of-type(1) {\n        animation-delay: 0;\n      }\n\n      .drop:nth-of-type(2) {\n        animation-delay: 0.5s;\n      }\n\n      .drop:nth-of-type(3) {\n        animation-delay: 1s;\n      }\n\n      .drop:nth-of-type(4) {\n        animation-delay: 1.5s;\n      }\n\n      .drop:nth-of-type(5) {\n        animation-delay: 2s;\n      }\n\n      .drop:nth-of-type(6) {\n        animation-delay: 2.5s;\n      }\n\n      .drop:nth-of-type(7) {\n        animation-delay: 3s;\n      }\n\n      .letter {\n        stroke-dasharray: 1000;\n        stroke-dashoffset: 1000;\n        animation: draw 3s ease-in-out forwards;\n      }\n\n      .letter-b {\n      animation-delay: 0s;\n      }\n\n      .letter-p {\n      animation-delay: 1s;\n      }\n\n      @keyframes drop {\n        0% {\n        transform: translate3d(0%, -20px, 0);\n        opacity: 1;\n        }\n        50% {\n        transform: translate3d(0%, 50%, 0);\n        opacity: 0.5;\n        }\n        100% {\n        transform: translate3d(0%, 100%, 0);\n        opacity: 0;\n        }\n        }\n\n        @keyframes draw {\n        0% {\n        stroke-dashoffset: 1000;\n        }\n        100% {\n        stroke-dashoffset: 0;\n        }\n        }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "uuid-e280b9ed-f19c-462b-afb1-46d1b489f8d0",
    "data-name": "Layer 16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "letter letter-p",
    d: "m216.07,112.14c-7.11-16.71-12.49-31.84-16.79-48.58.91-1.97,3.21-2.83,5.3-3.45,5.4-1.58,11.46-2.73,16.43-.15,6.29,3.26,8.26,12.62,3.82,18.16-2.25,2.81-5.6,4.46-8.83,6.03-2.09,1.02-4.42,2.06-6.66,1.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "letter letter-b",
    d: "m82.54,78.37c1.12,2.03,3.48,2.99,5.67,3.8,3.38,1.25,6.89,2.52,10.47,2.2,7.07-.64,12.45-8.54,10.46-15.33-1.58-5.38-6.61-8.96-11.49-11.76-1.89-1.08-4.1-2.15-6.15-1.44-9.1,14.69-16.3,29.05-23.08,45.49,1.4,1.07,2.93,1.97,4.54,2.66,1.43.61,2.92,1.06,4.41,1.51,3.65,1.1,7.4,2.21,11.2,1.93,3.8-.27,7.72-2.24,9.23-5.74.67-1.56.82-3.28.96-4.97.14-1.61.27-3.25-.15-4.81-.64-2.4-2.48-4.28-4.38-5.89-3.6-3.05-7.66-5.55-12-7.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-8e573da4-d366-4cfc-946e-224072da192e",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.51,126.54c12.5-25.01,32.54-48.03,58.29-66.95,20.86-15.33,46.58-28.33,75.86-31.6,37.12-4.15,66.99,8.22,94.32,26.85,27.33,18.63,45.84,42.99,62.5,67.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.29,127.12c5.69-2.48,13.6-3.65,23-3.38,7.62.22,16.59,1.46,25.99,4.77,11.91,4.2,20.38,10.18,27.61,16.86,7.23,6.68,11.29,13.14,14.77,19.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.74,161.56c1.94-5.9,6.34-12.57,12.81-19.4,5.24-5.54,12.14-11.4,20.88-16.19,11.07-6.08,21.18-8.41,30.97-9.35,9.8-.94,17.32.34,24.29,1.89",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m148.36,135.19c.08,11.06.16,12.66.24,23.72.19,26.12.37,52.24.56,78.35.09,12.69.19,25.49,2.84,37.91,1.36,6.37,4.02,13.33,10.01,15.89,6.86,2.92,15.05-1.69,18.69-8.2,3.64-6.51,3.88-14.3,4.04-21.76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-2612e58a-0140-4623-9796-e2db15e7586c",
    "data-name": "Layer 19"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "letter-w",
    d: "m171.81,45.12c-3.38-5.95-10.09-16.45-18.4-22.87-.01-1.84.08-3.74.17-5.71.14-2.85.28-5.8.1-8.76-.15-2.48-2.29-4.37-4.76-4.22-2.48.15-4.37,2.28-4.22,4.76.15,2.48.02,5.06-.11,7.79-.12,2.46-.24,4.99-.16,7.54-22.15,44.88-36.44,88.54-44.94,137.31-.34,1.96.64,3.9,2.41,4.79.64.32,1.33.48,2.02.48,1.21,0,2.4-.49,3.27-1.41,3.8-4.02,10.1-7.82,18.23-10.99,7.94-3.11,16.16-4.94,24.43-5.45,10.45-.64,19.76.74,30.21,4.49,9.02,3.24,15.02,7.58,19.93,11.38,1.37,1.06,3.22,1.24,4.77.47,1.55-.77,2.52-2.36,2.49-4.09-.52-36.73-12.11-74.51-35.43-115.5Zm11.18,39.35c-4.24,12.23-7.78,25.21-10.51,38.6-.37,1.81-1.92,3.13-3.77,3.2-.05,0-.1,0-.15,0-1.78,0-3.35-1.18-3.85-2.9l-8.28-29.04c-2.84,9.27-5.28,18.89-7.29,28.74-.37,1.81-1.92,3.13-3.77,3.2-1.85.07-3.49-1.13-4-2.9l-9.43-33.06c-.71-2.47-1.43-5.03-2.38-7.12-.91-2.01-.02-4.38,1.99-5.3,2.01-.91,4.38-.02,5.3,1.99,1.19,2.63,2.01,5.48,2.79,8.23l5.16,18.09c2.13-8.36,4.57-16.51,7.29-24.36.03-.07.05-.15.08-.22l.67-1.62c.61-1.47,2.04-2.44,3.63-2.47,1.59-.02,3.05.89,3.71,2.34,1.19,2.63,2.01,5.48,2.79,8.23l5.16,18.09c2.13-8.36,4.57-16.51,7.29-24.36.72-2.09,3-3.19,5.09-2.47s3.19,3,2.47,5.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "m192.67,190.37c-4.22,6.75-7.37,14.16-9.31,21.87-.34,1.34-.64,2.74-.33,4.08.69,3.06,4.52,4.67,7.49,3.67s4.97-3.93,5.7-6.98c.98-4.13,0-8.45-.97-12.58-.72-3.05-1.44-6.1-2.16-9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "m237,154.41c-4.22,6.75-7.37,14.16-9.31,21.87-.34,1.34-.64,2.74-.33,4.08.69,3.06,4.52,4.67,7.49,3.67s4.97-3.93,5.7-6.98c.98-4.13,0-8.45-.97-12.58-.72-3.05-1.44-6.1-2.16-9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "m279,162.36c-4.22,6.75-7.37,14.16-9.31,21.87-.34,1.34-.64,2.74-.33,4.08.69,3.06,4.52,4.67,7.49,3.67s4.97-3.93,5.7-6.98c.98-4.13,0-8.45-.97-12.58-.72-3.05-1.44-6.1-2.16-9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "m65.89,169.37c-4.22,6.75-7.37,14.16-9.31,21.87-.34,1.34-.64,2.74-.33,4.08.69,3.06,4.52,4.67,7.49,3.67s4.97-3.93,5.7-6.98c.98-4.13,0-8.45-.97-12.58-.72-3.05-1.44-6.1-2.16-9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "m24.08,150.64c-4.22,6.75-7.37,14.16-9.31,21.87-.34,1.34-.64,2.74-.33,4.08.69,3.06,4.52,4.67,7.49,3.67,2.97-1,4.97-3.93,5.7-6.98.98-4.13,0-8.45-.97-12.58-.72-3.05-1.44-6.1-2.16-9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "drop",
    d: "m117.3,199.29c-4.22,6.75-7.37,14.16-9.31,21.87-.34,1.34-.64,2.74-.33,4.08.69,3.06,4.52,4.67,7.49,3.67,2.97-1,4.97-3.93,5.7-6.98.98-4.13,0-8.45-.97-12.58-.72-3.05-1.44-6.1-2.16-9.15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 8
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgUmbrella);
export default __webpack_public_path__ + "static/media/SVG_umbrella.562021b80c2936046e6e446f07992705.svg";
export { ForwardRef as ReactComponent };